import { groupBy, sortBy } from 'lodash/fp';
import { Category, Color } from '../../server-types';

export interface ChildCategoryOption {
    id: string;
    name: string;
    color: Color;
    parent?: boolean;
}

export const getChildCategoryOptions = (categories: Category[]) => {
    const sortedCategories = sortBy(['name', 'desc'], categories);

    const parentCategories: Category[] = [];
    const childCategories: Category[] = [];

    sortedCategories.forEach(category => {
        const hasParent = !!category.categoryId;

        if(hasParent){
            childCategories.push(category);
        } else {
            parentCategories.push(category);
        }
    });

    const groupedByParent = groupBy('categoryId', childCategories);
    const options: ChildCategoryOption[] = [];

    parentCategories.forEach(({ id, name, color }) => {
        const parentColor = color || Color.Blue;
        options.push({ id, name, color: parentColor, parent: true });

        const children = groupedByParent[id];

        if(children) {
            children.forEach(({ id: childId, name: childName }) => {
                options.push({ id: childId, name: childName, color: parentColor });
            });
        }
    });

    return options;
};